import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'app/app-config.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ConstantsService {

    constructor(private http: HttpClient,
        private configService: AppConfigService) {

    }

    getConstants(type: string): Observable<Array<string>> {
        return this.http.get<Array<string>>(`${this.configService.getConfiguration().apiUrl}/Constant/${type}`);
    }

}
